import styled from "styled-components";

export const GalleryContainer = styled.div`
  max-height: 360px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px;

  /* สำคัญ: กัน parent/child บางตัวตั้ง min-height แปลกๆ */
  min-height: 0;
  height: auto;
  position: relative;

  && .ant-upload-wrapper,
  && .ant-upload-picture-card-wrapper {
    display: block;
    width: 100%;
    max-width: 100%;
  }

  /* ✅ ปิด “scroll/height lock” ของ list ที่มักทำให้ container ไม่ขยาย */
  && .ant-upload-picture-card-wrapper .ant-upload-list,
  && .ant-upload-wrapper .ant-upload-list {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;     /* <-- จุดสำคัญ */
    overflow-x: hidden !important;
    overflow-y: visible !important;
    white-space: normal !important;
  }

  /* wrap ที่คุณทำไว้ */
  && .ant-upload-picture-card-wrapper .ant-upload-list.ant-upload-list-picture-card {
    display: flex !important;
    flex-wrap: wrap !important;
    width: 100% !important;
    gap: 8px;
    align-content: flex-start;
  }

  && .ant-upload-picture-card-wrapper .ant-upload-list-item-container {
    flex: 0 0 auto;
    margin: 0 !important;
  }
`;

type UploadGalleryProps = {
  children: React.ReactNode;
  maxHeight?: number;
};

export const UploadGalleryStyle = ({
  children,
  maxHeight = 360,
}: UploadGalleryProps) => {
  return (
    <GalleryContainer style={{ maxHeight }}>
      {children}
    </GalleryContainer>
  );
};